

















import Vue from "vue";

export default Vue.extend({
  name: "cwx-btn",

  props: {
    //Gives the button an appearance of the 'primary' button
    primary: {
      type: Boolean,
      required: false,
      default: false
    },
    //Removes the button background color
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    //Set the button color to $base-color
    primaryTextColor: {
      type: Boolean,
      required: false,
      default: false
    },
    //The button with icon only
    icon: {
      type: Boolean,
      required: false,
      default: false
    },
    //Gives the button an appearance of the 'disabled' button
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
